import { NgModule } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { RouterModule, Routes, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuthGuard, redirectUnauthorizedTo } from '@angular/fire/compat/auth-guard';
import { Observable } from 'rxjs';
import { FirestoreDbService } from './_services/firestore-db.service';
import { Firestore } from '@angular/fire/firestore';

const redirectUnauthorizedToLogin = ()=> redirectUnauthorizedTo(['login']);
// const redirectUnauthorizedToLogin = ((next: ActivatedRouteSnapshot, state: RouterStateSnapshot)=> {
//   redirectUnauthorizedTo('/login?returnUrl=' + state.url);
// });

const routes: Routes = [
  // { path: '', redirectTo: '/', pathMatch: 'full' },
  {
    path: '',  loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin}
  },
  {
    path: 'main',  loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin}
  },
  // { path: 'main',  loadChildren: () => import('./main/main.module').then(m => m.MainModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  // { path: 'clients',  loadChildren: () => import('./clients/clients.module').then(m => m.ClientsModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'clients/:id',  loadChildren: () => import('./client-edit/client-edit.module').then(m => m.ClientEditModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'campaigns',  loadChildren: () => import('./campaigns/campaigns.module').then(m => m.CampaignsModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'campaigns/:id',  loadChildren: () => import('./campaign-edit/campaign-edit.module').then(m => m.CampaignEditModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'lists',  loadChildren: () => import('./lists/lists.module').then(m => m.ListsModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'lists/:id',  loadChildren: () => import('./list-edit/list-edit.module').then(m => m.ListEditModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'flows',  loadChildren: () => import('./flows/flows.module').then(m => m.FlowsModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  {
    path: 'flows/:id',
    loadChildren: () => import('./flow-edit/flow-edit.module').then(m => m.FlowEditModule),
    canActivate: [AngularFireAuthGuard],
    data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'profiles',  loadChildren: () => import('./profiles/profiles.module').then(m => m.ProfilesModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'profiles/:id',  loadChildren: () => import('./profile-edit/profile-edit.module').then(m => m.ProfileEditModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'integrations/:id',  loadChildren: () => import('./integration-edit/integration-edit.module').then(m => m.IntegrationEditModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'templates',  loadChildren: () => import('./templates/templates.module').then(m => m.TemplatesModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'templates/:id',  loadChildren: () => import('./template-edit/template-edit.module').then(m => m.TemplateEditModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'template/:id',  loadChildren: () => import('./template-edit-grapesjs/template-edit-grapesjs.module').then(m => m.TemplateEditGrapesjsModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'popups',  loadChildren: () => import('./popups/popups.module').then(m => m.PopupsModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'popups/:id',  loadChildren: () => import('./popup-edit/popup-edit.module').then(m => m.PopupEditModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'popup/:id',  loadChildren: () => import('./popup-edit-grapesjs/popup-edit-grapesjs.module').then(m => m.PopupEditModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'login',  loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'spauth',  loadChildren: () => import('./router/router.module').then(m => m.RouterModule) },
  { path: 'af/:af',  loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'auth',  loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule), canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectUnauthorizedToLogin} },
  { path: 'auth/:param',  loadChildren: () => import('./auth-logged/auth-logged.module').then(m => m.AuthLoggedModule) },
  { path: 'auth/:param1/:param2',  loadChildren: () => import('./auth-logged/auth-logged.module').then(m => m.AuthLoggedModule) },
  {
    path: 'account',
    loadChildren: () => import('./user-settings/user-settings.module').then(m => m.UserSettingsModule),
    canActivate: [AngularFireAuthGuard],
    data: {
      authGuardPipe: redirectUnauthorizedToLogin,
      animationState: 'Three'
    }
  },
  // {
  //     path: 'lactaciones',
  //     loadChildren: 'app/hist-lactaciones/hist-lactaciones.module#HistLactacionesModule',
  //     canActivate: [RoleGuard],
  //     data: {
  //         expectedRole: 6,
  //         expectedModule: 4
  //     }
  // },
  // { path: 'login',  loadChildren: 'app/login/login.module#LoginModule' },
  // { path: 'login/recover',  loadChildren: 'app/login/login.module#LoginModule' },

  {
    path: '**',
    loadChildren: () => import('./url-checker/url-checker.module').then(m => m.UrlCheckerModule),
    // redirectTo: '/main'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
